import { onKeyStroke } from '@vueuse/core'
import { useCommandPalette } from '@dashboard/composables/useCommandPalette'
import { useRightyStore } from '../stores/rightyStore'

export function isRightyShortcutBlocked() {
  return (
    useCommandPalette().isOpen.value ||
    [...document.querySelectorAll<HTMLElement>('[aria-modal="true"], dialog[open]')].some(
      (dialog) => getComputedStyle(dialog).display !== 'none' && getComputedStyle(dialog).visibility !== 'hidden'
    )
  )
}

export function toggleRightyFromShortcut(): boolean {
  if (isRightyShortcutBlocked()) {
    return false
  }
  const rightyStore = useRightyStore()
  rightyStore.focusInputOnOpen = !rightyStore.isDrawerOpen
  rightyStore.toggleDrawer()
  return true
}

export function useRightyKeyboardShortcuts() {
  const rightyStore = useRightyStore()

  onKeyStroke('/', (event) => {
    if (
      (event.metaKey || event.ctrlKey) &&
      !event.altKey &&
      !event.repeat &&
      !event.defaultPrevented &&
      toggleRightyFromShortcut()
    ) {
      event.preventDefault()
    }
  })

  onKeyStroke('Escape', () => {
    if (rightyStore.isDrawerOpen) {
      rightyStore.closeDrawer()
    }
  })
}
